import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
    MenuTabs
} from "libraries/component/booking-information/components/booking-price-card/booking-price-card.component";
import {BookingType} from "@afidium/ts-facade/model/bookingType";
import {DisplayType} from "../../../../../menu-details-tarifications/menu-details-tarifications.component";
import {Subscription} from "rxjs";
import {PricesTableService} from "../../services/prices-table.service";
import {PriceInBookingType} from "@afidium/ts-facade/model/priceInBookingType";
import {ECostOrRetail} from "../../booking-price-card.enum";

@Component({
    selector: 'prices-summary',
    templateUrl: './prices-summary.component.html',
    styles: [``],
})
export class PricesSummaryComponent implements OnInit, OnDestroy {

    @Input()
    public selectedTab: MenuTabs;

    @Input()
    public displayListOrTable: DisplayType;

    @Input()
    public booking: BookingType;

    public displayPricesTableType: DisplayType = DisplayType.pricesTable;
    public displayTarificationsListType: DisplayType = DisplayType.tarificationsList;
    public costOrRetail: string = ECostOrRetail.cost;
    public selectedPrice: PriceInBookingType;
    public rateSelectedSubscription: Subscription;

    public constructor(
        private readonly pricesTablesService: PricesTableService
    ) {
    }

    public ngOnInit(): void {
        this.costOrRetail = this.selectedTab === MenuTabs.buy ? ECostOrRetail.cost : ECostOrRetail.retail;
        this.rateSelectedSubscription = this.pricesTablesService.rateSelectedSubject.subscribe((rateSelected: string): void => {
            if (rateSelected === null) {
                this.selectedPrice = null;
            } else {
                this.selectedPrice = this.pricesTablesService.getRateByXRole(rateSelected, this.booking, 'cost');
                document.querySelector('#price').scrollIntoView();
            }
        });
    }

    public ngOnDestroy(): void {
        this.rateSelectedSubscription.unsubscribe();
    }
}